import React from "react";
import BaptizeAmericaLogo from "../../assets/baptize-america-logo.png";
import CertificateOfBaptism from "../../assets/certificate-of-baptism.png";
import "./CertificatePreview.css";
import { CertificateFormData } from "./types";

export default function CertificatePreview({
  data,
}: {
  data: CertificateFormData;
}) {
  const bibleVerses = {
    corinthians: `Therefore, if anyone is in Christ, he is a new creation. The old has passed away; behold, the new has come. — 2 Corinthians 5:17 (ESV)`,
    colossians: `If then you have been raised with Christ, seek the things that are above, where Christ is, seated at the right hand of God. — Colossians 3:1 (ESV)`,
    romans: `We were buried therefore with him by baptism into death, in order that, just as Christ was raised from the dead by the glory of the Father, we too might walk in newness of life. — Romans 6:4 (ESV)`,
  };

  const [verse, reference] = bibleVerses[data.designChoice].split(" — ");

  return (
    <div className="certificate-container">
      <img
        src={CertificateOfBaptism}
        alt="Certificate of Baptism"
        className="certificate-image"
      />

      <p className="subtitle">
        ON THIS DATE, {data.baptismDate.toUpperCase()}, YOU CONFIRMED YOUR
        COMMITMENT TO
        <br />
        JESUS CHRIST THROUGH WATER BAPTISM.
      </p>

      <h2 className="name">{data.name || "NAME"}</h2>

      <div className="hr" />

      <p className="verse-text">{verse}</p>
      <p className="verse-ref">{reference}</p>

      <img
        src={BaptizeAmericaLogo}
        alt="Baptize America Logo"
        className="logo-image"
      />
    </div>
  );
}
